module.exports = __webpack_public_path__ + "img/gift-bg2.1e4944cc.png";